import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleCheck,
  faCircleXmark,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import { theme as themeConfig } from 'styles/theme';
import { changeProfilePasswordSchema } from 'validation/profileSchemas';

export type PasswordRulesStatus = 'neutral' | 'success' | 'error';

export type RulesTextColor = 'primary' | 'green' | 'red' | 'grey';

export function getPasswordRulesStatus(
  password: string | undefined
): PasswordRulesStatus {
  const pwd = password ?? '';
  if (!pwd) return 'neutral';
  const ok = changeProfilePasswordSchema
    .pick(['password'])
    .isValidSync({ password: pwd });
  return ok ? 'success' : 'error';
}

type RulesPresentation = {
  rulesTitleColor: RulesTextColor;
  rulesBodyColor: RulesTextColor;
  rulesIcon: IconDefinition;
  rulesIconColor: string;
};

export function getPasswordRulesPresentation(
  status: PasswordRulesStatus
): RulesPresentation {
  const rulesTitleColor: RulesPresentation['rulesTitleColor'] =
    status === 'neutral' ? 'primary' : status === 'success' ? 'green' : 'red';
  const rulesBodyColor: RulesPresentation['rulesBodyColor'] =
    status === 'neutral' ? 'grey' : rulesTitleColor;
  const rulesIcon: IconDefinition =
    status === 'neutral'
      ? faInfoCircle
      : status === 'success'
        ? faCircleCheck
        : faCircleXmark;
  const rulesIconColor =
    status === 'neutral'
      ? themeConfig.palette.neutral.grey
      : status === 'success'
        ? themeConfig.palette.accent.green
        : themeConfig.palette.text.red;

  return {
    rulesTitleColor,
    rulesBodyColor,
    rulesIcon,
    rulesIconColor
  };
}
